import { InputLabel, Select } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import DIRECTV_GO from '~/assets/DIRECTV_GO_LOGO_HORIZONTAL_RGB.svg';
import logoSky from '~/assets/log-SKY.svg';
import history from '~/services/history';
import { ApplicationState } from '~/store';
import { companyAllRequest } from '~/store/ducks/common/actions';
import getValidationErrors from '~/utils/getValidationErrors';
import { Container, FormControlLGPD, StyledButton } from './styles';

const Helpe: React.FC = props => {
  const dispatch = useDispatch();

  const companyAll = useSelector<ApplicationState, any>(
    state => state.common.companyAll,
  );

  const [ownership, setOwnership] = useState<number>(0);

  const setLogo = (company: any) => {
    if (company === '1') {
      return logoSky;
    } else {
      return DIRECTV_GO;
    }
  };

  const [formErr, setFormErr] = useState<any>({});

  const handleChangeOwnership = (
    event: React.ChangeEvent<{
      name?: string | undefined;
      value: any;
    }>,
  ) => {
    setOwnership(event.target.value);
    setFormErr({
      ...formErr,
      ownership_type: false,
    });
  };

  const login = useCallback(async () => {
    try {
      const data = {
        ownership_type: ownership,
      };

      const schema = Yup.object().shape({
        ownership_type: Yup.string().test(
          'ownership_type',
          'Categoria obrigatoria',
          value => {
            return value !== '0' && value !== '' ? true : false;
          },
        ),
      });

      await schema.validate(data, { abortEarly: false });

      history.push(`/${companyAll[ownership - 1].path_alias_nm}`);
    } catch (e) {
      if (e instanceof Yup.ValidationError) {
        const err = getValidationErrors(e);

        toast.error('Por favor, selecionar uma empresa.');

        setFormErr(err);
      }
    }
  }, [companyAll, ownership]);

  useEffect(() => {
    dispatch(companyAllRequest());
  }, [dispatch]);

  return (
    <Container
      style={{
        height: '100vh',
        width: '100vw',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div className="select-empresas">
        <h1>Selecione a empresa que você deseja fazer o login</h1>
        {ownership != 0 ? <img src={setLogo(ownership)} alt={`logo`} /> : ''}
        <FormControlLGPD
          variant="outlined"
          ownershipTypeError={!!formErr?.ownership_type ? true : false}
        >
          <InputLabel htmlFor="outlined-ownershipType-native-simple">
            Empresa
          </InputLabel>
          <Select
            native
            value={ownership}
            onChange={handleChangeOwnership}
            label="Categoria"
            inputProps={{
              name: 'ownershipType',
              id: 'ownershipType',
            }}
          >
            <option aria-label="ownershipType" value="" />
            {companyAll?.map((el: any, i: any) => (
              <option
                style={{ textTransform: 'uppercase' }}
                key={i + 1}
                value={i + 1}
              >
                {`${el.company.company_name}-${el.country.country_name}`}
              </option>
            ))}
          </Select>
        </FormControlLGPD>

        <StyledButton type="submit" className="button-continue" onClick={login}>
          Continuar
        </StyledButton>
      </div>
    </Container>
  );
};

export default Helpe;
